<div class="sign-in-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="daxa-form ml-auto mr-auto border-radius bg-white"
                [class.card-borderd-theme]="themeService.isCardBorder()"
                [class.component-dark-theme]="themeService.isDark()" [class.rtl-enabled]="themeService.isRTLEnabled()">
                <div class="logo">
                    <img src="images/newLogo.jpg" alt="logo" class="rounded-circle">
                </div>
                <div class="title text-center">

                    <!-- <h3>Sign in</h3> -->
                    <!-- <p class="text-black">
                        Don’t have an account yet? <a routerLink="/authentication/sign-up" class="text-daxa">Sign Up</a>
                    </p> -->
                </div>
                <div class="error text-danger d-flex justify-content-center mb-10" *ngIf="errorMessage()">
                    {{ errorMessage() }}
                </div>
                <form [formGroup]="authForm" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                        <label class="main-label d-block lh-1 text-black">
                            Username
                        </label>
                        <mat-form-field>
                            <mat-label>
                                Enter your username
                            </mat-label>
                            <input matInput type="text" id="username" formControlName="username"
                                (keydown.enter)="$event.preventDefault(); goToNextInput('password')">
                        </mat-form-field>
                        <div class="error text-danger"
                            *ngIf="authForm.get('username')!.hasError('required') && authForm.get('username')!.touched">
                            username is required.
                        </div>
                        <div class="error text-danger"
                            *ngIf="authForm.get('username')!.hasError('username') && authForm.get('username')!.touched">
                            Please enter a valid username.
                        </div>
                        <div class="error text-danger"
                            *ngIf="authForm.get('username')!.hasError('maxlength') && authForm.get('username')!.touched">
                            Username must be at most 20 characters long.
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="main-label d-block lh-1 text-black">
                            Your Password
                        </label>
                        <mat-form-field>
                            <mat-label>
                                Enter your password
                            </mat-label>
                            <input matInput [type]="hide ? 'password' : 'text'" id="password"
                                formControlName="password">
                            <button mat-icon-button type="button" matSuffix (click)="hide = !hide"
                                [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                                <span class="material-symbols-outlined">
                                    {{hide ? 'visibility_off' : 'visibility'}}
                                </span>
                            </button>
                        </mat-form-field>
                        <div class="error text-danger"
                            *ngIf="authForm.get('password')!.hasError('required') && authForm.get('password')!.touched">
                            Password is required.
                        </div>
                        <div class="error text-danger"
                            *ngIf="authForm.get('password')!.hasError('minlength') && authForm.get('password')!.touched">
                            Password must be at least 8 characters long.
                        </div>
                    </div>

                    <div class="info d-flex justify-content-between align-items-center">
                        <mat-checkbox formControlName="rememberMe">
                            Remember me
                        </mat-checkbox>
                        <!-- <a routerLink="/authentication/forgot-password" class="d-inline-block text-daxa">
                            Forgot Password?
                        </a> -->
                    </div>
                    <button mat-button class="btn" type="submit" [disabled]="authForm.invalid || isLoading()">
                        <span *ngIf="!isLoading()">Sign In</span>
                        <span *ngIf="isLoading()">Loading...</span>
                    </button>
                    <!-- <div class="signin-with-socials text-center">
                        <div class="or position-relative">
                            <span class="d-inline-block">
                                or sign in with
                            </span>
                        </div>
                        <div class="socials">
                            <button mat-button type="button" class="facebook">
                                <i class="ri-facebook-fill"></i>
                            </button>
                            <button mat-button type="button" class="twitter">
                                <i class="ri-twitter-x-fill"></i>
                            </button>
                            <button mat-button type="button" class="google">
                                <i class="ri-google-fill"></i>
                            </button>
                            <button mat-button type="button" class="linkedin">
                                <i class="ri-linkedin-fill"></i>
                            </button>
                        </div>
                    </div> -->
                </form>
            </div>
        </div>
    </div>
</div>